import type { ApiClient, components } from '@bitwize/api-client';

/**
 * The contact form's endpoints. The one mutating public request on the
 * whole site — everything else here is a `GET`.
 */

export type ContactRequest = components['schemas']['ContactRequest'];
export type ContactAccepted = components['schemas']['ContactAccepted'];

/**
 * A signed render timestamp. The submit endpoint refuses a form completed
 * faster than a human can type; signing what "the form was rendered at
 * this time" means is what stops a bot forging an older one.
 */
export function getContactFormToken(
  client: ApiClient,
): Promise<{ token: string; expires_in: number }> {
  return client.request('/contact/form-token');
}

export function submitContact(client: ApiClient, body: ContactRequest): Promise<ContactAccepted> {
  return client.request<ContactAccepted>('/contact', { method: 'POST', body });
}
